<template>
  <el-select
    size="small"
    placeholder="可多选"
    multiple
    :value="value"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { userList } from '@/service/getData'
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await userList({
        page: 0,
        size: 40,
        status: 1,
        module_id: 2,
      })
      this.options = res.data.list
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>